var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:container"},[_vm._v(_vm._s(_vm.$t('titles.endOfLife')))])
}
var staticRenderFns = []

export { render, staticRenderFns }